const initialTeamCompetency = {
    team_competency: {},
    updated_team_competency: true,
};

export default initialTeamCompetency;